import * as React from "react";
import { ILang } from "../../i18n/ILang";
import { useTranslations } from "../../i18n/useTranslations";
import { ChallengesSection } from "../ChallengesSection";
import { DiscoverSection } from "../DiscoverSection";
import { PopularItemsList } from "./PopuplarItemsList";

export function PopularItems() {
  const { t, lang } = useTranslations();
  return (
    <div className="lg:elm-max-w-screen-lg elm-mx-auto elm-pt-16">
      <div className="elm-mb-7">
        <div
          role="heading"
          className="elm-text-dd-gray-900 elm-font-sans elm-text-sm elm-font-normal elm-uppercase elm-m-0 elm-mb-3"
        >
          {t("Popular")}
        </div>
        <PopularItemsList />
      </div>
      {lang !== ILang.es && (
        <div className="elm-grid md:elm-grid-cols-2 md:elm-grid-flow-col elm-grid-flow-row md:elm-gap-5 elm-gap-7">
          <div className="elm-flex elm-flex-col elm-order-2 md:elm-order-1">
            <DiscoverSection />
          </div>
          <div className="elm-flex elm-flex-col elm-order-1 md:elm-order-2">
            <ChallengesSection />
          </div>
        </div>
      )}
    </div>
  );
}
